import { Box, HStack, Heading, Avatar, Grid, Text, useColorModeValue } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

const Header = () => {
  const user = useSelector(state => state.user);
  const borderColor = useColorModeValue('whiteAlpha.300', 'whiteAlpha.200');
  
  return (
    <Box 
      bg="header.bg" 
      color="white" 
      py={3} 
      px={4} 
      boxShadow="card.shadow" 
      borderBottom="2px solid" 
      borderColor={borderColor}
    >
      <Grid templateColumns="1fr auto 1fr" align="center">
        {/* Left spacer to keep logo centered */}
        <Box />
        
        <HStack spacing={2} justify="center">
          <Text fontSize="24px">⚾</Text>
          <Heading 
            size="md" 
            letterSpacing="tight" 
            fontWeight="900"
            textTransform="uppercase"
            fontFamily="'HEX Franklin MLB', sans-serif"
          >
            Ballometer
          </Heading>
        </HStack>

        <HStack spacing={3} justify="flex-end">
          <Avatar 
            size="sm" 
            border="2px solid" 
            borderColor="brand.red"
            color="brand.red"
            fontWeight="900"
            fontSize="xs"
            lineHeight="1"
            name={user?.isLoggedIn ? user.email : "Guest User"}
            bg="white"
          />
        </HStack>
      </Grid>
    </Box>
  );
};

export default Header;
